import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  accountUrl = appUrls.account;
  lineDetailsUrl = appUrls.lineDetails;
  constructor(private http: HttpClient) { }

  //only use in eader
  getAccountName() {
    return this.http.get(this.accountUrl.getAccount);
  }
  //getAccountDetailsById() {
  //  return this.http.get(this.accountUrl.getAccount)
  //}

  //getLinesDetailsOfAccount(accountUCID: string) {
  //  return this.http.get(this.accountUrl.getLinesDetails +"?accountUCID="+accountUCID)
  //}
  
  getLinesDetailsOfAccountPagination(object) {
    return this.http.post(this.accountUrl.getAccountLines, object);
  }

  //getCountLinesOfAccount(searchWordObject) {
  //  return this.http.post(this.accountUrl.linesCount, searchWordObject);
  //}





}
